import styled from 'styled-components';

export const Section = styled.section`
    margin-bottom: 32px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    z-index: 100;

    @media (max-width: 768px) {
        margin-bottom: 0;
    }
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 16px;
    padding: 0 16px;
    position: relative;
    z-index: 101;
    width: 100%;
`;

export const Title = styled.h2`
    margin: 0;
    font-size: 18px;
    font-weight: 500;
    color: #2c3e50;
    display: flex;
    align-items: center;
    gap: 8px;

    svg {
        width: 20px;
        height: 20px;
        color: #7f8c8d;
    }
`;

export const Grid = styled.div`
    display: flex;
    flex-wrap: ${({ isCompactView }) => isCompactView ? 'nowrap' : 'wrap'};
    justify-content: ${({ isCompactView }) => isCompactView ? 'flex-start' : 'center'};
    gap: 12px;
    padding: 4px;
    min-height: 100px;
    overflow-x: ${({ isCompactView }) => isCompactView ? 'auto' : 'hidden'};
    scroll-snap-type: x mandatory;
    scrollbar-width: none;
    -ms-overflow-style: none;
    position: relative;
    z-index: 100;
    width: 100%;

    &::-webkit-scrollbar {
        display: none;
    }

    &.is-dragging-over {
        background: rgba(52, 152, 219, 0.05);
        border-radius: 8px;
    }
`;

export const EmptyState = styled.div`
    text-align: center;
    padding: 8px;
    background: rgba(1, 1, 1, 0.5);
    border-radius: 8px;
    color: #B6C2CF;
    backdrop-filter: blur(10px);
    max-width: 300px;
    position: relative;
    z-index: 100;
    margin: auto;

    p {
        margin: 0 0 16px;
        font-size: 16px;
    }

    svg {
        width: 24px;
        height: 24px;
        margin-bottom: 16px;
        color: #bdc3c7;
    }
`;

export const AddButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 4px 8px;
    border: none;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s ease;
    position: relative;
    z-index: 101;

    &:hover {
        background: rgba(0, 0, 0, 0.7);
    }

    svg {
        width: 16px;
        height: 16px;
    }
`;

export const IconButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: rgba(0, 0, 0, 0.7);
    }

    svg {
        width: 16px;
        height: 16px;
    }
`;

export const LoadingState = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    position: relative;
    z-index: 100;
`;

export const LoadingSpinner = styled.div`
    width: 32px;
    height: 32px;
    border: 3px solid #f5f6fa;
    border-top-color: #0984e3;
    border-radius: 50%;
    animation: spin 1s linear infinite;

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }
`;